import { render, staticRenderFns } from "./BookListItem.vue?vue&type=template&id=399cb0d2&"
import script from "./BookListItem.vue?vue&type=script&lang=js&"
export * from "./BookListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports